import { useAlertContext } from "provider/AlertProvider";
import { Modal, Button } from "react-bootstrap";

const AlertModal = ({
    onConfirm,
    title,
    confirmText = "Confirm",
    cancelText = "no",
    confirmVariant = "primary",
    cancelVariant = "secondary",
    showFooter = true,
    hideConfirm = false,
}) => {
    const { show, content, alertDispatch } = useAlertContext();
    const onHide = () => {
        alertDispatch({
      type: "ALERT_MODAL_TOGGLE",
      payload: {
        show: false,
        content: null,
        actionType:''
      },
    });
    }
    return (
        <Modal show={show} onHide={onHide} centered>
            {title && (
                <Modal.Header closeButton>
                    <Modal.Title>{title}</Modal.Title>
                </Modal.Header>
            )}
            <Modal.Body>{content}</Modal.Body>
            {showFooter && (
                <Modal.Footer>
                    <Button className="post-comment-cancel" variant={cancelVariant} onClick={onHide}>
                        {cancelText}
                    </Button>
                    {!hideConfirm && (
                        <Button className="post-comment" variant={confirmVariant} onClick={onConfirm}>
                            {confirmText}
                        </Button>
                    )}
                </Modal.Footer>
            )}
        </Modal>
    )
}
    ;

export default AlertModal;
